module.exports = __webpack_public_path__ + "img/team_wannabewize.00454373.jpg";